<template>
  <div class="container h-100">
    <div class="row h-100 justify-content-center">
      <div class="col-12 col-md-6 col-lg-4 align-self-center">
        <div class="d-flex justify-content-center">
        <img src="@/assets/svg/logo-horizontal.svg">
        </div>
        <div class="shadow p-4 mt-4 bg-white">
          <ci-form-login />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormLogin from '@/components/FormLogin.vue';

export default {
  name: 'LoginView',

  components: {
    'ci-form-login': FormLogin,
  },
};
</script>
